import * as tslib_1 from "tslib";
import { StreamType } from '../types';
import { actionKey } from './constants';
import { createAction } from 'redux-actions';
export var STREAM__WITH_CURSOR__INITIALIZE = actionKey + "__INITIALIZE";
export var STREAM__WITH_CURSOR__SET_CURSOR = actionKey + "__SET_CURSOR";
export var STREAM__WITH_CURSOR__FETCH = actionKey + "__FETCH";
export var STREAM__WITH_CURSOR__FETCH_SUCCESS = actionKey + "__FETCH_SUCCESS";
export var STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE = actionKey + "__FETCH_SUCCESS_DEDUPE";
export var STREAM__WITH_CURSOR__INSERT_ITEMS = actionKey + "__INSERT_ITEMS";
export var initialize = function (_a) {
    var streamId = _a.streamId, groupId = _a.groupId, _b = _a.streamParams, streamParams = _b === void 0 ? {} : _b, itemsPerFetch = _a.itemsPerFetch, items = _a.items, cursor = _a.cursor, prevCursor = _a.prevCursor, hasMore = _a.hasMore, hasLess = _a.hasLess, total = _a.total, entities = _a.entities;
    return ({
        type: STREAM__WITH_CURSOR__INITIALIZE,
        streamId: streamId,
        groupId: groupId,
        streamParams: streamParams,
        streamType: StreamType.WITH_CURSOR,
        itemsPerFetch: itemsPerFetch,
        items: items,
        cursor: cursor,
        prevCursor: prevCursor,
        hasMore: hasMore,
        hasLess: hasLess,
        total: total,
        entities: entities,
    });
};
export var setCursor = function (streamId, cursor) { return ({
    type: STREAM__WITH_CURSOR__SET_CURSOR,
    streamId: streamId,
    cursor: cursor,
}); };
export var fetch = function (streamId) { return ({
    type: STREAM__WITH_CURSOR__FETCH,
    streamId: streamId,
}); };
export var fetchSuccess = function (_a) {
    var streamId = _a.streamId, items = _a.items, entities = _a.entities, hasMore = _a.hasMore, total = _a.total, cursor = _a.cursor;
    return ({
        type: STREAM__WITH_CURSOR__FETCH_SUCCESS,
        streamId: streamId,
        items: items,
        entities: entities,
        hasMore: hasMore,
        total: total,
        cursor: cursor,
    });
};
export var fetchSuccessDeduped = function (payload) { return (tslib_1.__assign({ type: STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE }, payload)); };
export var insertItemsAtOffsetAndSetCursor = function (_a) {
    var streamId = _a.streamId, items = _a.items, offset = _a.offset, entities = _a.entities, newCursor = _a.newCursor;
    return ({
        type: STREAM__WITH_CURSOR__INSERT_ITEMS,
        streamId: streamId,
        items: items,
        offset: offset,
        entities: entities,
        newCursor: newCursor,
    });
};
export var fetchPrevious = createAction(actionKey + "__FETCH_PREVIOUS", function (streamId) { return ({ streamId: streamId }); });
export var fetchPreviousSuccess = createAction(actionKey + "__FETCH_PREVIOUS_SUCCESS", function (_a) {
    var streamId = _a.streamId, items = _a.items, entities = _a.entities, hasLess = _a.hasLess, prevCursor = _a.prevCursor, dedupeFunction = _a.dedupeFunction;
    return ({
        streamId: streamId,
        items: items,
        entities: entities,
        hasLess: hasLess,
        prevCursor: prevCursor,
        dedupeFunction: dedupeFunction,
    });
});
export { deleteItems, deleteStream, fetchFailure, replaceItem, } from '../base/actions';
//# sourceMappingURL=actions.js.map